import { showConfirmDialog, showDialog, showToast } from "vant";
import StorageUtil from "@/utils/StorageUtil";
import RouterUtil from "@/utils/RouterUtil";
import CommonUtil from "@/utils/CommonUtil";
import axios from "axios";
import config from "@/config";
import SessionUtil from "@/utils/SessionUtil";
import { ref } from "@vue/reactivity";
import OrderApi from "@/api/order-api";
import ReturnTripApi from "@/api/return-trip";
export default {
  name: "ReturnTripPassengerForm",
  props: {
    userData: {
      type: Object,
      require: true,
      default: {}
    },
    adcode: {
      type: Boolean,
      require: false,
      default: false
    },
    startProvince: {
      type: String,
      require: false,
      default: null
    },
    startCity: {
      type: String,
      require: false,
      default: null
    },
    startDistrict: {
      type: String,
      require: false,
      default: null
    },
    startAddress: {
      type: String,
      require: false,
      default: null
    },
    startPosition: {
      type: Number,
      require: false,
      default: null
    },
    endProvince: {
      type: String,
      require: false,
      default: null
    },
    endCity: {
      type: String,
      require: false,
      default: null
    },
    endDistrict: {
      type: String,
      require: false,
      default: null
    },
    endAddress: {
      type: String,
      require: false,
      default: null
    },
    endPosition: {
      type: Number,
      require: false,
      default: null
    },
    showDepartureTimeDatePickerClick: {
      type: Function,
      require: false,
      default: null
    },
    returnTripPassengerFormSuccess: {
      type: Function,
      require: false,
      default: null
    }
  },
  data() {
    return {
      seats_count: 1,
      //departure_time: CommonUtil.formatDate(new Date(), "MM月DD日 HH:mm"),
      departure_time: null,
      departure_time_date: null,
      departure_time_hour_min: null,
      estimated_distance: null,
      estimated_duration: null,
      estimated_cost: null,
      nowStartAddress: this.startAddress,
      nowStartPosition: this.startPosition,
      nowEndAddress: this.endAddress,
      nowEndPosition: this.startPosition,
      nowStartProvinceName: this.startProvince,
      nowStartCityName: this.startCity,
      nowStartDistrictName: this.startDistrict,
      nowEndProvinceName: this.endProvince,
      nowEndCityName: this.endCity,
      nowEndDistrictName: this.endDistrict,
      lastSeatsCount: 0,
      showDepartureTimeDatePicker: false
    };
  },
  watch: {
    departure_time_date() {
      if (this.departure_time_date && this.departure_time_hour_min) {
        this.departure_time = this.departure_time_date + " " + this.departure_time_hour_min;
      }
    },
    departure_time_hour_min() {
      if (this.departure_time_date && this.departure_time_hour_min) {
        this.departure_time = this.departure_time_date + " " + this.departure_time_hour_min;
      }
    },
    seats_count() {
      if (this.nowEndAddress) {
        const that = this;
        OrderApi.getFuturePrices("RETURN_TRIP", {
          orderBeginAddressLongitude: this.nowStartPosition[0],
          orderBeginAddressLatitude: this.nowStartPosition[1],
          orderTargetAddressLongitude: this.nowEndPosition[0],
          orderTargetAddressLatitude: this.nowEndPosition[1],
          peopleCount: this.seats_count
        }).then(function (result) {
          if (result.data) {
            const tolls = 0;
            if (result.data.data.length > 0) {
              that.estimated_duration = result.data.data[1].duration;
              that.estimated_distance = result.data.data[1].distance;
              //that.estimated_cost = (result.data.data[1].cost * that.seats_count) + tolls;
              that.estimated_cost = result.data.data[1].cost + tolls;
            }
          }
        });
      }
    }
  },
  mounted() {},
  activated() {
    const that = this;
    const addressData = StorageUtil.getObject("addressData");
    if (addressData) {
      console.log(addressData);
      if (addressData.type === "start") {
        this.nowStartAddress = addressData.address;
        this.nowStartPosition = addressData.position;
        this.nowStartProvinceName = addressData.provinceName;
        this.nowStartCityName = addressData.cityName;
        this.nowStartDistrictName = addressData.districtName;
      }
      if (addressData.type === "end") {
        this.nowEndAddress = addressData.address;
        this.nowEndPosition = addressData.position;
        this.nowEndProvinceName = addressData.provinceName;
        this.nowEndCityName = addressData.cityName;
        this.nowEndDistrictName = addressData.districtName;
      }
      OrderApi.getFuturePrices("RETURN_TRIP", {
        orderBeginAddressLongitude: this.nowStartPosition[0],
        orderBeginAddressLatitude: this.nowStartPosition[1],
        orderTargetAddressLongitude: this.nowEndPosition[0],
        orderTargetAddressLatitude: this.nowEndPosition[1]
      }).then(function (result) {
        if (result.data) {
          const tolls = 0;
          if (result.data.data.length > 0) {
            that.estimated_duration = result.data.data[1].duration;
            that.estimated_distance = result.data.data[1].distance;
            that.estimated_cost = result.data.data[1].cost * that.seats_count + tolls;
          }
        }
      });
    }
  },
  methods: {
    clickSeatsCount(val) {
      if (this.lastSeatsCount === val) {
        this.seats_count = 0;
        this.lastSeatsCount = 0;
      } else {
        this.lastSeatsCount = val;
      }
    },
    goSelectAddress(type, point) {
      //StorageUtil.setObject("returnTripPositionData", {
      StorageUtil.setObject("positionData", {
        type: type,
        position: point
      });
      RouterUtil.go("/address");
    },
    submitOrder(immediately) {
      const that = this;
      ReturnTripApi.publish({
        coordinate_type: "GCJ02",
        immediately: immediately,
        order_type: "RETURN_TRIP_ORDER_TYPE_ON_TIME",
        publish_longitude: this.startPosition[0],
        publish_latitude: this.startPosition[1],
        contact_person_name: this.userData.nick_name,
        contact_person_phone_number: this.userData.phone_number,
        seats_count: this.seats_count,
        departure_address_province: this.nowStartProvinceName,
        departure_address_city: this.nowStartCityName,
        departure_address_district: this.nowStartDistrictName,
        departure_address_description: this.nowStartAddress,
        departure_address_longitude: this.nowStartPosition[0],
        departure_address_latitude: this.nowStartPosition[1],
        destination_address_province: this.nowEndProvinceName,
        destination_address_city: this.nowEndCityName,
        destination_address_district: this.nowEndDistrictName,
        destination_address_description: this.nowEndAddress,
        destination_address_longitude: this.nowEndPosition[0],
        destination_address_latitude: this.nowEndPosition[1],
        estimated_duration: this.estimated_duration,
        estimated_distance: this.estimated_distance,
        estimated_cost: this.estimated_cost
      }).then(function (response) {
        const rs = response.response.data;
        if (rs.code === 200) {
          if (that.returnTripPassengerFormSuccess) {
            that.returnTripPassengerFormSuccess();
          }
        } else if (rs.code === 2010011) {
          showDialog({
            message: "发布行程失败，存在进行中的订单"
          });
        } else if (rs.code === 40100008) {
          showDialog({
            message: "发布行程失败，座位数不足"
          });
        } else if (rs.code === 4040009) {
          showDialog({
            message: "发布行程失败，没有匹配到司机"
          });
        } else if (rs.code === 4010011) {
          showDialog({
            message: "非常抱歉，暂时没有匹配到行程"
          });
        } else {
          showDialog({
            message: "发布行程失败，请稍后重试"
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};